import store from '@/store/index'

export default {
  openFile (file) {
    store.dispatch('getFile', file)
      .then(url => {
        const filename = file.split('\\').pop().split('/').pop()
        const link = document.createElement('a')
        link.href = url // Set blob url
        link.download = filename // Set file name
        document.body.appendChild(link)
        link.click() // Open link
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        }, 100)
      })
      .catch(err => console.error(err))
  }
}
